import React from 'react';
import { get, set } from 'lodash';
import { useContext } from 'react';

import { Checkbox } from 'src/presentation/components/agent_desktop_components';
import FormContext from 'src/presentation/contexts/FormContext';

const ReversedValueCheckbox = ({ attr, 'data-aid': dataAid, label, ...otherProps }) => {
  const { errors, workingState, resetError, updateState } = useContext(FormContext);
  const value = get(workingState, attr);

  const handleChange = event => {
    const checked = event.target.value === 'checked';
    resetError({ attr, errors });
    updateState(set({}, attr, checked));
  };

  const val = !value;

  return (
    <Checkbox
      checked={val}
      data-aid={dataAid}
      label={label}
      onChange={handleChange}
      value={val ? 'checked' : ''}
      {...otherProps}
    />
  );
};

export default ReversedValueCheckbox;
